import { render } from "./SuperMarioScene.vue?vue&type=template&id=6f3c176a"
import script from "./SuperMarioScene.vue?vue&type=script&lang=js"
export * from "./SuperMarioScene.vue?vue&type=script&lang=js"

import "./SuperMarioScene.vue?vue&type=style&index=0&id=6f3c176a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__